"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[MeetingReadinessCheckerConfiguration]] includes custom settings used for MeetingReadinessChecker
 */
var MeetingReadinessCheckerConfiguration = function MeetingReadinessCheckerConfiguration() {
  _classCallCheck(this, MeetingReadinessCheckerConfiguration);
  /**
   * Specify how long to wait for each check in a test.
   * If null, it will use the default value.
   */
  this.timeoutMs = 10000;
  /**
   * Specify the wait time before checking again when a check condition is not met.
   * If null, it will use the default value.
   */
  this.waitDurationMs = 3000;
};
exports.default = MeetingReadinessCheckerConfiguration;